import createReducer from '../../../../helpers/createReducer';
import { createFetchManyHandler } from '../../../../helpers/reducerRoutineCrudHandler';

import { fetchVisitConfigs } from '../../../sagas/visit/routines';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  fetchingError: null
};

export default createReducer(initialState, {
  ...createFetchManyHandler(fetchVisitConfigs)
});
